// https://play.tailwindcss.com/w3N3yreAjn?file=css
module.exports = () => ({
  ".breadcrumb": {
    "@apply ds-px-sm ds-py-[2rem]": true,
  },
  ".breadcrumb ul": {
    "@apply ds-flex ds-flex-wrap ds-list-none ds-m-0 ds-p-0": true,
  },
  ".breadcrumb li:not(:last-child)::after": {
    "@apply ds-inline-block ds-mx-2xs ds-content-['/']": true,
  },
});
